export default __webpack_public_path__ + "static/media/split-promotional-content-background.6583b09a.png";